import {
	SET_ITEM_TYPES,
	SET_ITEM_TYPE,
	CLEAR_ITEM_TYPES,
	CLEAR_ITEM_TYPE,
	ADD_ITEM_TYPE,
	UPDATE_ITEM_TYPE,
	REMOVE_ITEM_TYPE,
} from './actionTypes';

export const itemType = (state = {}, action) => {
	switch (action.type) {
		case SET_ITEM_TYPE:
			return action.payload;
		case UPDATE_ITEM_TYPE:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_ITEM_TYPE:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_ITEM_TYPES:
			return action.payload;
		case ADD_ITEM_TYPE:
			return [...state, action.payload];
		case UPDATE_ITEM_TYPE:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_ITEM_TYPE:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_ITEM_TYPES:
			return [];
		default:
			return state;
	}
};
